import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UrlSanitizerPipe } from './url-sanitizer.pipe';
import { HeroStylePipe } from './hero-style.pipe';



@NgModule({
  declarations: [
    UrlSanitizerPipe,
    HeroStylePipe,
  ],
  exports: [
    UrlSanitizerPipe,
    HeroStylePipe
  ],
  imports: [
    CommonModule
  ]
})
export class PipesModule { }
